import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6 mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left text-primary me-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, "Booking Details", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, " Date & Time ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0 mt-2" }, " Booked for ", -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = {
  key: 0,
  class: "shadow-sm p-3 mb-5 rounded-1"
}
const _hoisted_11 = { class: "d-flex align-items-center mb-4" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "fw-bold" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_15 = { class: "p-0 text-secondary mb-3" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex mb-3"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-3",
  src: "/images/Location.png",
  style: {"max-height":"20px"}
}, null, -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 1,
  class: "d-flex mb-3"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-3",
  src: "/images/Phone.png"
}, null, -1)
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "d-flex mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-3",
  src: "/images/Email.png",
  style: {"height":"12px","margin-top":"5px"}
}, null, -1)
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold mb-3" }, "Dine-in hours", -1)
const _hoisted_26 = { class: "p-0" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Today ")

import { ref, computed } from 'vue';
import Header from '@/components/shared/PageHeader.vue';
import Footer from '@/components/shared/PageFooter.vue';
import PageTitle from '@/components/shared/PageTitle.vue';
import  CardLoader from '@/components/shared/loaders/CardLoader.vue';
import { useRoute } from 'vue-router';
import { store } from '@/store';
import { getUTCDate, formatFullDate, getAddress, isBeforeTheDefinedTime } from '@/utils/helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingDetails',
  setup(__props) {

const bookingDetails = ref(null) as any;
const no_records = ref(false);
const dine_in_hours = ref([]) as any;
const route = useRoute();
const bookingId = route.params.id;
const restaurantsConfiguration = ref(null) as any;

const isAbleToCancel = computed(() => {
    if(bookingDetails.value && bookingDetails.value.restaurant && bookingDetails.value.status !== 'C') {
        const cancelTime = restaurantsConfiguration.value?.dine_in_configuration?.user_can_cancel_table_only_up_to_minutes_before ;
        // restaurantsConfiguration?.dine_in_configuration?.user_can_cancel_table_only_up_to_minutes_before 
        const bookingTime = bookingDetails.value?.datetime;
        return isBeforeTheDefinedTime(bookingTime, cancelTime);
    }
    return false;
});

const getUserBookingDetails = () => {

    store.dispatch('getUserBookingDetails', bookingId).then((response) => {
        bookingDetails.value = response;
        if(response.restaurant?.id)
            restaurantByID(response.restaurant?.id);
    }).catch((error) => {
        console.log(error);
    });
}

const restaurantByID = (ID: number) => {
    store.dispatch('restaurantByID', ID).then(res => {
        if(res) {
            bookingDetails.value.restaurant = res;
            openingHours();

        }
    });
}

const openingHours = () => {

    dine_in_hours.value = [];
    const name = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const now = new Date().toUTCString();
    let gg  = Date.parse(now);
    const DAY = 60 * 60 * 24 * 1000;
    for (let i = 0; i < 7; i++) {
        const date = new Date(gg + DAY * i);
        let day = getUTCDate(date);
        if(bookingDetails.value && bookingDetails.value.restaurant.dine_in_hours && day) {
            let Obj =  { 
                date: name[date.getUTCDay()], 
                hours: bookingDetails.value.restaurant?.dine_in_hours[day],
                isToday: i == 0 ? true : false
            };
            dine_in_hours.value.push(Obj);
        }
    }
}

const cancelBooking = () => {
    if(!isAbleToCancel.value) {
        return;
    }

    store.dispatch('cancelUserBooking', bookingId).then((response) => {
        getUserBookingDetails();
    }).catch((error) => {
        console.log(error);
    });
}

const getConfig = () => {
    store.dispatch('restaurantsConfiguration').then((response) => {
        restaurantsConfiguration.value = response;
    }).catch((error) => {
        console.log(error);
    });
}

getUserBookingDetails()
getConfig();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header),
    _createVNode(PageTitle, { title: "My Bookings" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/bookings",
            class: "text-primary d-flex align-items-center mb-4"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("p", null, _toDisplayString(_unref(formatFullDate)(_unref(bookingDetails)?.datetime ?? '')), 1),
          _hoisted_7,
          _createElementVNode("p", null, _toDisplayString(_unref(bookingDetails)?.no_of_guests) + " Guests", 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary rounded-5 fw-bold me-2 mt-2 px-5",
            onClick: cancelBooking,
            disabled: !_unref(isAbleToCancel)
          }, " Cancel Booking ", 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_unref(bookingDetails)?.restaurant)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_unref(bookingDetails).restaurant.logo_thumbnails.square_thumbnail)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(bookingDetails).restaurant.logo_thumbnails.square_thumbnail,
                        class: "me-3 rounded-circle"
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, [
                    _createElementVNode("h3", _hoisted_13, _toDisplayString(_unref(bookingDetails).restaurant.name), 1),
                    _createElementVNode("h6", null, [
                      (_unref(bookingDetails).restaurant.cuisines && _unref(bookingDetails).restaurant.cuisines.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(bookingDetails).restaurant.cuisines[0].name), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_14
                          ], 64))
                    ])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_15, [
                  (_unref(bookingDetails).restaurant.address)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_unref(getAddress)(_unref(bookingDetails).restaurant.address)) + " ", 1),
                        (_unref(bookingDetails).restaurant.location && _unref(bookingDetails).restaurant.location && _unref(bookingDetails).restaurant.location.longitude && _unref(bookingDetails).restaurant.location.longitude)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: `https://www.google.com/maps/dir/?api=1&destination=${_unref(bookingDetails).restaurant.location.latitude},${_unref(bookingDetails).restaurant.location.longitude}`,
                              class: "ms-2 text-primary",
                              target: "_blank"
                            }, " View on map ", 8, _hoisted_18))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(bookingDetails).restaurant.phone_number)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("a", {
                          href: `tel:${_unref(bookingDetails).restaurant.phone_number}`,
                          class: "text-secondary"
                        }, _toDisplayString(_unref(bookingDetails).restaurant.phone_number), 9, _hoisted_21)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("a", {
                      href: `mailto:${_unref(bookingDetails).restaurant.email}`,
                      class: "text-secondary"
                    }, _toDisplayString(_unref(bookingDetails).restaurant.email), 9, _hoisted_24)
                  ])
                ]),
                _hoisted_25,
                _createElementVNode("ul", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dine_in_hours), (date_item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: date_item.date,
                      class: "d-flex mb-2"
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-uppercase fw-bold date-item", date_item.isToday ? 'text-primary' : 'text-muted'])
                      }, [
                        (date_item.isToday)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_27
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(date_item.date), 1)
                            ], 64))
                      ], 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(date_item.isToday ? 'text-primary' : 'text-secondary')
                      }, _toDisplayString(date_item.hours), 3)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createBlock(CardLoader, { key: 1 }))
        ])
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})